import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MotiveRefuzComponent } from './motive-refuz.component';
import { AddMotiveRefuzComponent } from './add-motive-refuz/add-motive-refuz.component';
import { EditMotiveRefuzComponent } from './edit-motive-refuz/edit-motive-refuz.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        MotiveRefuzComponent,
        AddMotiveRefuzComponent,
        EditMotiveRefuzComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [MotiveRefuzComponent]
})
export class MotiveRefuzModule { }
